/*
 * Layout Name: Service Category Grid
 * Desc:
 */
import React from "react"
import { connect } from "react-redux"
//components
import SiteWrapper from "../../../structure/SiteWrapper/SiteWrapper"
import * as styles from "./ServiceCategoryGrid.module.scss"

const ServiceCategoryGrid = ({ staticData, openServiceStep }) => {
  const { serviceCategoryOptions } = staticData

  const handleSubmit = (event) => {
    const serviceCategoryId = event.target.value
    const serviceCategory = serviceCategoryOptions.find(
      (serviceCategory) => serviceCategory.id === serviceCategoryId
    )
    openServiceStep(serviceCategory?.options)
  }

  const servicesElement =
    serviceCategoryOptions && serviceCategoryOptions.length
      ? serviceCategoryOptions.map((serviceCategory) => {
          return serviceCategory ? (
            <li key={serviceCategory.id} className={styles.box}>
              <input
                type="checkbox"
                id={serviceCategory.id}
                name={serviceCategory.label}
                value={serviceCategory.id}
                onChange={handleSubmit}
              />
              <label htmlFor={serviceCategory.id}>
                <div className={styles.image}>
                  {serviceCategory.image ? (
                    <img
                      src={serviceCategory.image.url + "?w=800&h=500&fit=crop&fm=jpg"}
                      alt={serviceCategory.label}
                    />
                  ) : null}
                </div>
                <span>{serviceCategory.label}</span>
              </label>
            </li>
          ) : null
        })
      : null

  return (
    <section className={styles.ServiceCategoryGrid}>
      <SiteWrapper full>
        <ul className={styles.grid}>{servicesElement}</ul>
      </SiteWrapper>
    </section>
  )
}

const mapStateToProps = (state) => {
  return {
    staticData: state.staticData.data,
  }
}

export default connect(mapStateToProps)(ServiceCategoryGrid)
